var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrint = function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M6.25 5A.75.75 0 0 1 7 4.25h10a.75.75 0 0 1 .75.75v3.25H19a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-1.25V20a.75.75 0 0 1-.75.75H7a.75.75 0 0 1-.75-.75v-3.25H5a.75.75 0 0 1-.75-.75V9A.75.75 0 0 1 5 8.25h1.25zm10 .75v2.5h-8.5v-2.5zm1.5 9.5h.5v-5.5H5.75v5.5h.5V13a.75.75 0 0 1 .75-.75h10a.75.75 0 0 1 .75.75zm-10 4v-5.5h8.5v5.5zM8 11a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m2 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-.75 4.5a.75.75 0 0 1 .75-.75h2.5a.75.75 0 0 1 0 1.5H10a.75.75 0 0 1-.75-.75m.75 1.25a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5z",
    clipRule: "evenodd"
  })));
};
export default SvgPrint;